import { z } from "zod";
import { ContactEmailType } from "@/enums/ContactEmailType";

export const CorrespondenceEntrySchema = z.object({
  date: z.string(),
  description: z.string(),
});

export const ActivityLogEntryListSchema = z.array(CorrespondenceEntrySchema);

export const ActivityLogContactActionSchema = z.object({
  label: z.string(),
  emailType: z.nativeEnum(ContactEmailType),
});

export const ActivityLogContactActionListSchema = z.array(ActivityLogContactActionSchema);

export const ActivityLogContactSchema = z.object({
  name: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  actions: ActivityLogContactActionListSchema,
  selectedAction: ActivityLogContactActionSchema.optional().nullable(),
});

export const ActivityLogContactListSchema = z.array(ActivityLogContactSchema);

const ActivitySchema = z.object({
  userName: z.string(),
  activityType: z.string(),
  activityDate: z.coerce.date(),
  projectCode: z.string().nullable(),
  projectName: z.string().nullable(),
  drawNumber: z.number().nullable(),
  description: z.string(),
});

export const ActivityListSchema = z.array(ActivitySchema);

export const ActivityLogInfoSchema = z.object({
  entries: ActivityLogEntryListSchema,
  contacts: ActivityLogContactListSchema,
  reachedAllocatedInspectionRequests: z.boolean(),
  activityLog: ActivityListSchema,
});

export type CorrespondenceEntry = z.infer<typeof CorrespondenceEntrySchema>;
export type ActivityLogInfo = z.infer<typeof ActivityLogInfoSchema>;
export type ActivityLogContact = z.infer<typeof ActivityLogContactSchema>;
export type ActivityLogContactAction = z.infer<typeof ActivityLogContactActionSchema>;
export type Activity = z.infer<typeof ActivitySchema>;
